import { connect } from 'react-redux';

import Component from './Component';

const mapStateToProps = () => ({});

const actionCreators = {};

export default connect(mapStateToProps, actionCreators)(Component);